'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


/**
 * Provides the ElementConnectionsManager to other components via the React context.
 */
var ElementConnectionsContextProvider = function (_React$Component) {
    _inherits(ElementConnectionsContextProvider, _React$Component);

    function ElementConnectionsContextProvider(props, context) {
        _classCallCheck(this, ElementConnectionsContextProvider);

        var _this = _possibleConstructorReturn(this, (ElementConnectionsContextProvider.__proto__ || Object.getPrototypeOf(ElementConnectionsContextProvider)).call(this, props, context));

        _this.manager = props.manager;
        return _this;
    }

    _createClass(ElementConnectionsContextProvider, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return { elementConnectionsManager: this.manager };
        }
    }, {
        key: 'getManager',
        value: function getManager() {
            return this.elementConnectionsManager;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.Children.only(this.props.children);
        }
    }]);

    return ElementConnectionsContextProvider;
}(_react2.default.Component);

ElementConnectionsContextProvider.propTypes = {
    children: _propTypes2.default.element.isRequired,
    manager: _propTypes2.default.object.isRequired
};

ElementConnectionsContextProvider.childContextTypes = {
    elementConnectionsManager: _propTypes2.default.object.isRequired
};

exports.default = ElementConnectionsContextProvider;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/components/ElementConnectionsContextProvider.js
// module id = 1705
// module chunks = 0